export default __webpack_public_path__ + "static/media/fkm.06e6cac8.png";